import { useEffect, useState } from 'react';

/**
 * FE-27 — `matchMedia` como estado de React. Se usa para decidir en JS lo que
 * el CSS ya decide con el mismo corte (`MOBILE_MEDIA_QUERY`): aquí, si el
 * histórico de recorrido navega a su página propia o abre el panel flotante.
 */
export function useMediaQuery(query: string): boolean {
  const getMatch = () => typeof window !== 'undefined' && window.matchMedia(query).matches;
  const [matches, setMatches] = useState(getMatch);

  useEffect(() => {
    const mql = window.matchMedia(query);
    const onChange = () => setMatches(mql.matches);
    onChange();
    mql.addEventListener('change', onChange);
    return () => mql.removeEventListener('change', onChange);
  }, [query]);

  return matches;
}
